import React from 'react';
import styled from 'styled-components';
import Container from 'components/layout/Container';
import { Link } from 'react-router-dom';

const NavBar = styled.nav`
  background: #eef2f7;
  border-bottom: 1px solid #dbe3ee;
`;

const Wrapper = styled(Container)`
  display: flex;
  justify-content: center;
`;

const Menu = styled.ul`
  display: flex;
  gap: 22px;
  list-style: none;
  margin: 0;
  padding: 12px 0;

  li {
    display: block;
  }

  a {
    border-radius: 6px;
    color: #17345c;
    display: block;
    font-size: 15px;
    font-weight: 700;
    padding: 11px 16px;
    text-decoration: none;
    transition: background-color 120ms ease, color 120ms ease;
  }

  a:hover {
    background: #ffffff;
    color: #0d2340;
  }

  a.active {
    background: #ffffff;
    color: #0d2340;
  }

  @media (max-width: 720px) {
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 6px;
    width: 100%;
  }
`;

const NavHome = () => (
  <NavBar>
    <Wrapper>
      <Menu>
        <li>
          <Link to="/" className="active">Inicio</Link>
        </li>
        <li>
          <Link to="/acercade">Modelo de proyección PMR</Link>
        </li>
        <li>
          <a href="http://www.diplomacambioclimatico.cl/" target="_blank" rel="noopener noreferrer">
            Diplomado Cambio Climático
          </a>
        </li>
        <li>
          <a href="http://centroenergia.cl/contacto/" target="_blank" rel="noopener noreferrer">
            Contacto
          </a>
        </li>
      </Menu>
    </Wrapper>
  </NavBar>
);

export default NavHome;
